import React from 'react';
import PropTypes from 'prop-types';

const SlicePayment = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.2013 0.039229C17.3566 -0.0455219 16.6667 0.650617 16.6667 1.49953V2.09157C16.6668 2.09157 16.6667 2.09156 16.6667 2.09157L16.6666 8.64391L16.6667 8.66669V14.5161C16.6753 14.9659 17.0401 15.3285 17.4908 15.3333H17.8991L17.9196 15.3334L30.5006 15.3333C31.3495 15.3333 32.0456 14.6435 31.9609 13.7988C31.8111 12.3067 31.4436 10.8417 30.8676 9.45115C30.0951 7.58627 28.9629 5.89179 27.5356 4.46447C26.1083 3.03715 24.4138 1.90494 22.5489 1.13248C21.1584 0.556495 19.6934 0.188942 18.2013 0.039229Z" fill={color} />
    <path d="M14.9999 2.00003C6.71574 2.00014 0.00012207 8.71582 0.00012207 17C0.00012207 25.2843 6.71585 32 15.0001 32C23.2844 32 30.0001 25.2843 30.0001 17L21.2328 17C21.7559 17.6964 22.0658 18.562 22.0658 19.5C22.0658 21.8012 20.2003 23.6667 17.8991 23.6667H16.6667V25.3334C16.6667 26.2538 15.9205 27 15.0001 27C14.0796 27 13.3334 26.2538 13.3334 25.3334V23.6667H10.1667C9.24622 23.6667 8.50003 22.9205 8.50003 22C8.50003 21.0795 9.24622 20.3334 10.1667 20.3334H13.3334V18.6666H12.5C10.1989 18.6666 8.3334 16.8012 8.3334 14.5C8.3334 12.1988 10.1989 10.3334 12.5 10.3334H13.3334V8.66669C13.3334 7.74627 14.0795 7.00011 14.9999 7.00003V2.00003Z" fill={color} />
    <path d="M13.3334 13.6667H12.5C12.0398 13.6667 11.6667 14.0398 11.6667 14.5C11.6667 14.9602 12.0398 15.3333 12.5 15.3333H13.3334V13.6667Z" fill={color} />
    <path d="M16.6667 18.6666V20.3334H17.8991C18.3594 20.3334 18.7325 19.9603 18.7325 19.5C18.7325 19.0398 18.3594 18.6666 17.8991 18.6666H16.6667Z" fill={color} />
  </svg>
);

SlicePayment.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

SlicePayment.defaultProps = {
  color: '#18223D',
  size: 20,
};

export default SlicePayment;
